import { LIMIT_STATUS, LIMIT_TYPE } from './constants';

export const parseAutomaticWithdrawLimits = ({ limits = [] }) => {
    const currentLimits = limits.filter(item => item.status === LIMIT_STATUS.CURRENT);
    const pendingLimits = limits.filter(item => item.status === LIMIT_STATUS.PENDING);
    const limit = currentLimits.find(item => item.limitType === LIMIT_TYPE.AUTOMATIC_WITHDRAW_LIMIT) || {};
    const amountToBeLeftOnBalance = currentLimits.find(item => item.limitType === LIMIT_TYPE.AMOUNT_TO_BE_LEFT_ON_BALANCE) || {};

    return {
        limit: {
            endDate: limit.endDate,
            amount: limit.limit?.amount,
            currencyCode: limit.limit?.currencyCode
        },
        amountToBeLeftOnBalance: {
            endDate: amountToBeLeftOnBalance.endDate,
            amount: amountToBeLeftOnBalance.limit?.amount,
            currencyCode: amountToBeLeftOnBalance.limit?.currencyCode
        },
        pendingLimits: pendingLimits.map(pendingLimit => ({
            limitType: pendingLimit.limitType,
            startDate: pendingLimit.startDate,
            amount: pendingLimit.limit.amount,
            currencyCode: pendingLimit.limit.currencyCode
        }))
    };
};
